import React from "react"
import {Route, Routes} from "react-router-dom"
import {Repo} from "../../pages/Repo"
import {NewRepo} from "../../pages/Repo/NewRepo"
import {Repos} from "../../pages/Repos"

export const RepoRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Repos/>}/>
      <Route path="/new" element={<NewRepo/>}/>
      <Route path="/:profileOrbitId/:publicKey/:orbitId/:repoId/*" element={<Repo/>}/>
    </Routes>
  )
}
